import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';
import { PackingType, PackingTypeFilters } from '../../models/PackingType';

const usePackingTypeService = () => {
  const { doGet, doPost, doPut, doDelete } = useFetch();

  const [fetchingGetPackingTypes, setFetchingGetPackingTypes] = useState(false);
  const [fetchingShowPackingType, setFetchingShowPackingType] = useState(false);
  const [fetchingCreatePackingType, setFetchingCreatePackingType] = useState(false);
  const [fetchingStorePackingType, setFetchingStorePackingType] = useState(false);
  const [fetchingEditPackingType, setFetchingEditPackingType] = useState(false);
  const [fetchingUpdatePackingType, setFetchingUpdatePackingType] = useState(false);
  const [fetchingDeletePackingType, setFetchingDeletePackingType] = useState(false);
  const [fetchingActivePackingType, setFetchingActivePackingType] = useState(false);

  // Listado de tipos de empaque
  const getPackingTypes = (packingTypeFilters: PackingTypeFilters, events: ServiceEvents = {}) => {
    const queryString = Object.entries(packingTypeFilters)
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

    const url = `${EndPoints.PACKING_TYPES.GET_PACKING_TYPES}?${queryString}`;

    doGet({
      ...events,
      url,
      setFetching: setFetchingGetPackingTypes
    });
  };

  // Mostrar un tipo
  const showPackingType = (id: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.PACKING_TYPES.SHOW_PACKING_TYPE.replace(':id', id.toString()),
      setFetching: setFetchingShowPackingType
    });
  };

  // Crear (GET formulario)
  const createPackingType = (events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.PACKING_TYPES.CREATE_PACKING_TYPE,
      setFetching: setFetchingCreatePackingType
    });
  };

  // Almacenar
  const storePackingType = (payload: PackingType, events: ServiceEvents = {}) => {
    doPost({
      ...events,
      url: EndPoints.PACKING_TYPES.STORE_PACKING_TYPE,
      body: payload,
      setFetching: setFetchingStorePackingType
    });
  };

  // Editar (GET datos existentes)
  const editPackingType = (id: number, events: ServiceEvents = {}) => {
    doGet({
      ...events,
      url: EndPoints.PACKING_TYPES.EDIT_PACKING_TYPE.replace(':id', id.toString()),
      setFetching: setFetchingEditPackingType
    });
  };

  // Actualizar
  const updatePackingType = (id: number, payload: PackingType, events: ServiceEvents = {}) => {
    doPut({
      ...events,
      url: EndPoints.PACKING_TYPES.UPDATE_PACKING_TYPE.replace(':id', id.toString()),
      body: payload,
      setFetching: setFetchingUpdatePackingType
    });
  };

  // Eliminar
  const deletePackingType = (id: number, events: ServiceEvents = {}) => {
    doDelete({
      ...events,
      url: EndPoints.PACKING_TYPES.DELETE_PACKING_TYPE.replace(':id', id.toString()),
      setFetching: setFetchingDeletePackingType
    });
  };

  // Activar/Desactivar
  const activePackingType = (id: number, events: ServiceEvents = {}) => {
    doPut({
      ...events,
      url: EndPoints.PACKING_TYPES.ACTIVE_PACKING_TYPE.replace(':id', id.toString()),
      setFetching: setFetchingActivePackingType
    });
  };

  return {
    fetchingGetPackingTypes,
    fetchingShowPackingType,
    fetchingCreatePackingType,
    fetchingStorePackingType,
    fetchingEditPackingType,
    fetchingUpdatePackingType,
    fetchingDeletePackingType,
    fetchingActivePackingType,
    getPackingTypes,
    showPackingType,
    createPackingType,
    storePackingType,
    editPackingType,
    updatePackingType,
    deletePackingType,
    activePackingType,
  };
};

export default usePackingTypeService;
